module.exports = __webpack_public_path__ + "static/media/Boy-Bedroom-1.35a02f2a.webp";